import React, { useEffect, useState, useRef } from 'react';
import { UsersIcon, PercentIcon, StarIcon, FileTextIcon, SearchIcon } from 'lucide-react';
const PlayerHeader = () => {
  const [isFavorite, setIsFavorite] = useState(false);
  const [showListPopover, setShowListPopover] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLists, setSelectedLists] = useState<string[]>([]);
  const popoverRef = useRef<HTMLDivElement>(null);
  const allLists = [{
    id: '1',
    name: 'Top Prospects 2024'
  }, {
    id: '2',
    name: 'Free Agents Watch'
  }, {
    id: '3',
    name: 'Trade Targets'
  }, {
    id: '4',
    name: 'Injury Recovery'
  }, {
    id: '5',
    name: 'Draft Board'
  }, {
    id: '6',
    name: 'Veteran Leaders'
  }, {
    id: '7',
    name: 'Defensive Specialists'
  }, {
    id: '8',
    name: 'Clutch Performers'
  }];
  const visibleLists = allLists.slice(0, 5);
  const searchableLists = allLists.filter(l => !visibleLists.find(v => v.id === l.id)).filter(l => l.name.toLowerCase().includes(searchQuery.toLowerCase()));
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target as Node)) {
        setShowListPopover(false);
        if (selectedLists.length === 0) setIsFavorite(false);
      }
    };
    if (showListPopover) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showListPopover, selectedLists]);
  const handleStarClick = () => {
    if (isFavorite) {
      setIsFavorite(false);
      setSelectedLists([]);
      setShowListPopover(false);
    } else {
      setIsFavorite(true);
      setShowListPopover(true);
    }
  };
  const toggleList = (id: string) => {
    setSelectedLists(prev => prev.includes(id) ? prev.filter(l => l !== id) : [...prev, id]);
  };
  return <div className="flex justify-between items-center" data-id="element-254" data-mp="dvcptpjcxo40">
      <h1 className="text-3xl font-bold" data-id="element-255" data-mp="9v1a8r5uqdze">NAME SURNAME</h1>
      <div className="flex items-center space-x-3" data-id="element-256" data-mp="4wzqs54ikcne">
        <div className="flex space-x-1" data-id="element-257" data-mp="4xj7jiifguzu">
          <div className="relative" ref={popoverRef} data-id="element-258" data-mp="3w3akthb3wd58">
            <button onClick={handleStarClick} className={`p-2 rounded-full transition-colors ${isFavorite ? 'text-yellow-500 bg-yellow-50' : 'text-gray-400 hover:bg-gray-200'}`} data-id="element-259" data-mp="3w4ve73lopq1i">
              <StarIcon className="w-5 h-5" fill={isFavorite ? 'currentColor' : 'none'} data-id="element-260" data-mp="soom7ucmth8k" />
            </button>

            {/* List Popover */}
            {showListPopover && <div className="absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden" data-id="element-261" data-mp="1gc69pdov5t5q">
                <div className="px-3 py-2 border-b bg-gray-50" data-id="element-262" data-mp="1bko60hvgheh2">
                  <p className="text-xs font-bold text-gray-600 uppercase tracking-wide" data-id="element-263" data-mp="1iwui35aan45a">
                    Add to list
                  </p>
                </div>
                <div className="max-h-52 overflow-y-auto" data-id="element-264" data-mp="1nxrx5900bi2k">
                  {visibleLists.map(list => {
                const isSelected = selectedLists.includes(list.id);
                return <button key={list.id} onClick={() => toggleList(list.id)} className="w-full flex items-center gap-2.5 px-3 py-2 hover:bg-gray-50 transition-colors text-left" data-id="element-265" data-mp="1xrikgakedmgo">
                        <StarIcon className={`w-4 h-4 flex-shrink-0 ${isSelected ? 'text-yellow-500' : 'text-gray-300'}`} fill={isSelected ? 'currentColor' : 'none'} data-id="element-266" data-mp="2bm1mum0ccpyz" />
                        <span className={`text-sm ${isSelected ? 'font-semibold text-gray-900' : 'text-gray-600'}`} data-id="element-267" data-mp="2pkj88d2rxqdq">
                          {list.name}
                        </span>
                      </button>;
              })}
                  {searchQuery && searchableLists.map(list => {
                const isSelected = selectedLists.includes(list.id);
                return <button key={list.id} onClick={() => toggleList(list.id)} className="w-full flex items-center gap-2.5 px-3 py-2 hover:bg-gray-50 transition-colors text-left" data-id="element-268" data-mp="34ajnhvkz3282">
                          <StarIcon className={`w-4 h-4 flex-shrink-0 ${isSelected ? 'text-yellow-500' : 'text-gray-300'}`} fill={isSelected ? 'currentColor' : 'none'} data-id="element-269" data-mp="38cwrofk2ms2q" />
                          <span className={`text-sm ${isSelected ? 'font-semibold text-gray-900' : 'text-gray-600'}`} data-id="element-270" data-mp="nlw7vze6rshc">
                            {list.name}
                          </span>
                        </button>;
              })}
                </div>
                <div className="border-t px-3 py-2" data-id="element-271" data-mp="r4bskx1fe8cg">
                  <div className="relative" data-id="element-272" data-mp="r4vdmmmdhcup">
                    <SearchIcon className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-273" data-mp="1eu67dk5b26zc" />
                    <input type="text" placeholder="Search lists" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-8 pr-3 py-1.5 text-sm border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-274" data-mp="1jtis9zcm93za" />
                  </div>
                </div>
              </div>}
          </div>
          <button className="p-2 rounded-full text-gray-400 hover:bg-gray-200" data-id="element-275" data-mp="2cg0r2kwgn5p9">
            <FileTextIcon className="w-5 h-5" data-id="element-276" data-mp="27gebi4t5tdda" />
          </button>
        </div>
        <button className="p-2 rounded-full bg-gray-200 hover:bg-gray-300" data-id="element-277" data-mp="27ebbcryam3uu">
          <UsersIcon className="w-5 h-5" data-id="element-278" data-mp="22fqaqrf4pi5v" />
        </button>
        <button className="p-2 rounded-full bg-gray-200 hover:bg-gray-300" data-id="element-279" data-mp="1yg943unyuez4">
          <PercentIcon className="w-5 h-5" data-id="element-280" data-mp="1tgmrnnfyp2rd" />
        </button>
      </div>
    </div>;
};
export default PlayerHeader;